import { Routes } from '@angular/router';
import { admissionsOnlyGuard, authGuard, noAuthGuard } from './core/guards/auth.guard';
import { gradeCorrectionAdminGuard } from './core/guards/grade-correction-admin.guard';

export const routes: Routes = [
  {
    path: 'pre-enrollment',
    loadComponent: () =>
      import('./features/pre-inscripcion/components/pages/pre-inscripcion-page/pre-inscripcion-page.component').then(
        (m) => m.PreEnrollmentPageComponent,
      ),
  },
  {
    path: 'login',
    canActivate: [noAuthGuard],
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/components/pages/login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'payment/success',
    loadComponent: () =>
      import('./features/payments/components/pages/payment-success-page/payment-success-page').then(
        (m) => m.PaymentSuccessPage,
      ),
  },
  {
    path: 'payment/cancel',
    loadComponent: () =>
      import('./features/payments/components/pages/payment-cancel-page/payment-cancel-page').then(
        (m) => m.PaymentCancelPage,
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [admissionsOnlyGuard],
    loadComponent: () =>
      import('./shared/components/layout/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/components/pages/dashboard-page/dashboard-page.component').then(
            (m) => m.DashboardPageComponent,
          ),
      },
      {
        path: 'history',
        loadChildren: () =>
          import('./features/academic-history/academic-history.routes').then(
            (m) => m.ACADEMIC_HISTORY_ROUTES,
          ),
      },
      {
        path: 'academic-history',
        loadChildren: () =>
          import('./features/academic-history/academic-history.routes').then(
            (m) => m.ACADEMIC_HISTORY_ROUTES,
          ),
      },
      {
        path: 'aula-virtual',
        loadComponent: () =>
          import('./features/aula-virtual/components/pages/aula-virtual-page/aula-virtual-page').then(
            (m) => m.AulaVirtualPage,
          ),
      },
      {
        path: 'pre-enrollment-documents',
        loadComponent: () =>
          import('./features/pre-inscripcion/components/pages/pre-enrollment-documents-page/pre-enrollment-documents-page').then(
            (m) => m.PreEnrollmentDocumentsPage,
          ),
      },
      {
        path: 'admissions/applicant-fields',
        loadComponent: () =>
          import('./features/pre-inscripcion/components/pages/applicant-fields-page/applicant-fields-page').then(
            (m) => m.ApplicantFieldsPage,
          ),
      },
      {
        path: 'payments',
        loadComponent: () =>
          import('./features/payments/components/pages/payments-shell/payments-shell').then(
            (m) => m.PaymentsShell,
          ),
        children: [
          {
            path: 'current',
            loadComponent: () =>
              import('./features/payments/components/pages/payments-current-page/payments-current-page').then(
                (m) => m.PaymentsCurrentPage,
              ),
          },
          {
            path: 'transactions',
            loadComponent: () =>
              import('./features/payments/components/pages/payments-transactions-page/payments-transactions-page').then(
                (m) => m.PaymentsTransactionsPage,
              ),
          },
          { path: '', redirectTo: 'current', pathMatch: 'full' },
        ],
      },
      {
        matcher: (segments) =>
          segments.length === 2 &&
          segments[0].path === 'admin' &&
          segments[1].path === 'grade-corrections'
            ? { consumed: segments }
            : null,
        canActivate: [gradeCorrectionAdminGuard],
        loadComponent: () =>
          import('./features/admin/grade-corrections-page/grade-corrections-page').then(
            (m) => m.GradeCorrectionsPage,
          ),
      },
      {
        path: 'admin',
        loadComponent: () =>
          import('./features/tramites/components/pages/procedures-page/procedures-page').then(
            (m) => m.ProceduresPage,
          ),
      },
      {
        path: 'schedule',
        loadComponent: () =>
          import('./features/horario/components/pages/schedule-page/schedule-page').then(
            (m) => m.SchedulePage,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/settings/components/pages/settings-page/settings-page.component').then(
            (m) => m.SettingsPage,
          ),
      },
      {
        path: 'inscription',
        loadComponent: () =>
          import('./shared/components/pages/under-construction/under-construction.component').then(
            (m) => m.UnderConstructionComponent,
          ),
      },
      {
        path: 'graduate',
        children: [
          {
            path: 'report-card',
            loadComponent: () =>
              import('./features/academic-history/components/pages/academic-history-page/academic-history-page.component').then(
                (m) => m.AcademicHistoryPageComponent,
              ),
          },
          {
            path: 'credential-history',
            loadComponent: () =>
              import('./shared/components/pages/under-construction/under-construction.component').then(
                (m) => m.UnderConstructionComponent,
              ),
          },
          {
            path: 'kardex',
            loadComponent: () =>
              import('./features/academic-history/components/pages/graduate-kardex-page/graduate-kardex-page').then(
                (m) => m.GraduateKardexPage,
              ),
          },
        ],
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
